export enum Country {
    GB = 'GB',
    AU = 'AU'
}

export const COUNTRY_NAMES: Record<Country, string> = {
    [Country.AU]: "Australia",
    [Country.GB]: "United Kingdom"
}

export function getProvincesByCountry(country: Country): string[] {
    const provinceByCountry: { [key in Country]: string[] } = {
        'GB': ['LDN'],
        'AU': ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'VIC', 'TAS', 'WA']
    };
    return provinceByCountry[country];
}
